import { createTheme, ThemeOptions } from "@mui/material";

import "@/assets/fonts/_fonts.scss";

export const PrimaryColor = "#000";

export const appThemeOptions: ThemeOptions = {
  typography: {
    fontFamily: [
      "Open Sans",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    // mode: "dark",
    // mode: "light",

    primary: {
      // light: will be calculated from palette.primary.main,
      main: PrimaryColor,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main,
      //   background: {
      //     default: "#e4f0e2",
      //   },
    },
    // secondary: {
    //   main: "#F7B47D",
    // },
    background: {
      default: "#FFF",
    },
    // background: {
    //   // default: 'cyan',
    //   default: "#e4f0e2",
    //   paper: "#e4f0e2",
    //   //   paper: React.CSSProperties['color'],
    // },
    // mutedLight: {
    //   main: '#c2c0c0',
    // },
    // mutedDark: {
    //   main: '#707070',
    // },
    // blackish: {
    //   main: '#000000',
    // },
    // blackish2: {
    //   main: '#323232',
    // },
    // whitish: {
    //   main: '#FFFFFF',
    // },
    // whitish2: {
    //   main: '#E6E6E6',
    // },
    // shadow: {
    //   main: '#6E7881',
    // },
    // shadowDark: {
    //   main: '#B1B1B1',
    // },
  },
};
const appTheme = createTheme(appThemeOptions);

export default appTheme;
